var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEhWesternSahara(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_17319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H-0.00431061V22.4983H60V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 22.4983H-0.00431061V44.9966H60V22.4983Z",
    fill: "#007A3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 13.1218H-0.00431061V31.8748H60V13.1218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0L30.0022 22.4983L60 44.9966V0Z",
    fill: "#C4111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0036 28.4996C11.6891 28.4996 9.00226 25.8127 9.00226 22.4983C9.00226 19.1838 11.6891 16.4969 15.0036 16.4969C18.318 16.4969 21.0049 19.1838 21.0049 22.4983C21.0049 25.8127 18.318 28.4996 15.0036 28.4996Z",
    fill: "#C4111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7477 28.4996C9.43328 28.4996 6.7464 25.8127 6.7464 22.4983C6.7464 19.1838 9.43328 16.4969 12.7477 16.4969C16.0621 16.4969 18.749 19.1838 18.749 22.4983C18.749 25.8127 16.0621 28.4996 12.7477 28.4996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.616 26.1291L14.0516 24.3049L11.5136 26.1555L12.4653 23.1593L9.9097 21.3175L13.0558 21.2998L14.0251 18.3036L15.0121 21.291L18.1582 21.2734L15.629 23.1417L16.6072 26.1379L16.616 26.1291Z",
    fill: "#C4111B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_17319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhWesternSahara);
export default __webpack_public_path__ + "static/media/eh Western Sahara.655b299f627459f60fe1d2c7f5e74e5d.svg";
export { ForwardRef as ReactComponent };